import React from 'react';
import { useQuery, useReactiveVar } from '@apollo/client';
import { Button, CircularProgress, Table, TableRow, TableCell, TableBody } from '@material-ui/core';
import { GetDestinationsByOrganizationDocument } from '../../generated/graphql';
import { lastAccessedOrganizationVar } from '../../cache';
import StyledLink from '../components/StyledLink';
import PageLayout from '../components/PageLayout';
import PageTitle from '../components/PageTitle';
var DestinationsListPage = function (props) {
    var _a;
    var currentOrganization = useReactiveVar(lastAccessedOrganizationVar);
    var query = new URLSearchParams(props.location.search);
    var organizationId = (_a = query.get('org')) !== null && _a !== void 0 ? _a : currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.id;
    var _b = useQuery(GetDestinationsByOrganizationDocument, {
        variables: { organizationId: organizationId },
        fetchPolicy: 'cache-and-network',
    }), data = _b.data, loading = _b.loading, error = _b.error;
    if (loading)
        return React.createElement(CircularProgress, null);
    if (error)
        return React.createElement("p", null, "ERROR");
    if (!data) {
        return (React.createElement(PageLayout, null,
            React.createElement(PageTitle, { title: "Datamart" }),
            React.createElement("div", null,
                React.createElement("p", null, "There is no Datamart on this Organization"),
                React.createElement(Button, { variant: "contained", color: "primary" },
                    React.createElement(StyledLink, { to: "/" }, "Create a Datamart")))));
    }
    return (React.createElement(PageLayout, null,
        React.createElement(PageTitle, { title: "Datamart" }),
        data.destinationsByOrganization.length ? (React.createElement(Table, null,
            React.createElement(TableBody, null, data.destinationsByOrganization.map(function (destination, i) { return (React.createElement(TableRow, { key: i },
                React.createElement(TableCell, null,
                    React.createElement(StyledLink, { to: "/destinations/" + destination.id + "?org=" + organizationId },
                        "Datamart #",
                        i + 1,
                        ": ",
                        destination.name)))); })))) : (React.createElement("div", null,
            React.createElement("p", null, "There is no Datamart on this Organization"),
            React.createElement(Button, { variant: "contained", color: "primary" },
                React.createElement(StyledLink, { to: "/" }, "Create a Datamart"))))));
};
export default DestinationsListPage;
